import classNames from 'classnames';
import EditableField from '../common/fields/EditableField';
import {Button} from '../common/Button';
import {CellItemProps} from '../../constants/types';
import {
  treatmentWithCodeValidationSchema
} from '../../constants/validationSchemes';
import EnsurePermission from '../common/EnsurePermission';
import permissionsInfo from '../../constants/permissionsInfo';

type RowProps = {
  isImmutable: boolean,
  cellItem: CellItemProps,
  addButtonLabel?: string,
  className?: string,
  handleDelete: () => void,
  handleCreate: () => void
}

const Row = ({
  isImmutable,
  cellItem,
  addButtonLabel,
  className,
  handleDelete,
  handleCreate
}: RowProps) => (
  <tr className={classNames({[`${className}`]: className})}>
    <td className="cell">
      {isImmutable ?
        cellItem.cellData.name :
        <EditableField
          cellItem={cellItem}
          validationSchema={treatmentWithCodeValidationSchema}
        />}
    </td>
    <td>
      {!isImmutable && <EnsurePermission
        elementPermissions={permissionsInfo.treatments.delete}>
        <Button onClick={handleDelete} label="Delete" variant="text" size="small" />
      </EnsurePermission>}
    </td>
    <td>
      {addButtonLabel && <EnsurePermission
        elementPermissions={permissionsInfo.treatments.create}>
        <Button onClick={handleCreate} label={addButtonLabel} variant="text" size="small" />
      </EnsurePermission>}
    </td>
  </tr>);

export default Row;
